module.exports = __webpack_public_path__ + "img/01_CAGUAMA.33ba3c61.png";